// @flow
import range from 'lodash/range';
import { connect } from 'react-redux';

import * as selectors from '../../../../reducers';
import WeekSchedule from '../../../WeekSchedule';


export default connect(
  (state, { stopId, occupiedDays, value = [] }) => {
    const stop = selectors.getRouteStop(state, stopId);
    const route = selectors.getRoute(state, stop.route);

    return {
      disabledWeekDays: (
        range(7)
          .filter(
            day => !(route.week_days || []).includes(day),
          )
      ),
      conflictedWeekDays: value.filter(lValue => occupiedDays.has(lValue)),
    };
  },
  undefined,
)(WeekSchedule);



// WEBPACK FOOTER //
// ./src/scripts/components/StudentSchedulingPopup/RouteStopsScheduler/RouteStopWeekSchedule/index.jsx